// 与 nihaov2 保持一致；可通过环境变量覆盖
export const TURNSTILE_SITE_KEY =
  process.env.VUE_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAD1jcfn-ZzqEagIP";
